import React from "react";
import SearchSelect from "components/ui/SearchSelect";
import { SHARING_STATES, DEFAULT_SHARING_STATE } from "utils/sharing";

// One record type's sharing state. Shared by the Network, Division,
// Organization and Office forms so the three states read the same everywhere.
//
// Inherit is not the same as Closed: inherit takes whatever a level above
// decided, closed is a deliberate opt-out that overrides it.
export default function SharingRow({
  recordType,
  value,
  onChange,
  disabled,
}) {
  return (
    <div className="flex items-start gap-3.5 px-4 py-3 border-t border-mediumgray first:border-t-0">
      <div className="min-w-0">
        <div className="font-medium text-black">{recordType.name}</div>
        <div className="text-xs text-darkgray mt-0.5">
          {recordType.description}
        </div>
      </div>
      <div className="ml-auto flex-shrink-0 w-40">
        <SearchSelect
          options={SHARING_STATES}
          value={
            SHARING_STATES.find(
              (state) => state.value === (value || DEFAULT_SHARING_STATE),
            ) || null
          }
          onChange={(option) =>
            onChange(option?.value || DEFAULT_SHARING_STATE)
          }
          placeholder="Inherit"
          searchable={false}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
